export default "__VITE_ASSET__C87Oj8Jg__"